import React from 'react'
import {Row, Grid} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getMonthEvents } from './EventsProvider';
import TimetableContainer from './roomTimetable/TimetableContainer';
import moment  from 'moment';
import { SingleDatePicker} from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import styled from 'styled-components';
import { GridLoader } from 'react-spinners';

const DateInputSpacer = styled.div`
  margin: 17px 0;
`
const LoaderDiv = styled.div`
  display: flex;
  position: absolute;
  margin-top: 413px;
  left: 50%;
`

const FullDiv =  styled.div`
  width: 100%;
`
const ContactBoldDiv = styled.div`
    width: 100%;
    text-align: center;
    font-weight: 500;
    margin-top: 10px;
`
const ContactdDiv = styled.div`
    width: 100%;
    text-align: center;
`
const TextDiv = styled.div`
  width: 100%;
  margin-top: 20px;
  font-size: larger;
  text-align: center;
  font-weight:500;
`
const LogoImg = styled.img`
  width: 90%;
  margin-left: 10%;
`

class App extends React.Component {
  constructor () {
    super()
    this.state = {
      events: [
        {room: 1, bookings:[]},
        {room: 2, bookings:[]},
        {room: 3, bookings:[]},
        {room: 4, bookings:[]},
        {room: 5, bookings:[]}
    ],
    selectedDay:moment(),
    loading: true,
    day: moment().tz("Europe/London").startOf('day'),
    focused: true
    }
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount () {
    getMonthEvents(moment().startOf('month').format("YYYY-MM-DD"),(events) => {
      this.setState({
        events: events, 
        loading: false
        })
    })
  }

  handleChange(date) {
    if (!this.state.selectedDay.isSame(date,'month')) {
      this.setState({
        loading: true
        },
        getMonthEvents(moment(date).startOf('month').format("YYYY-MM-DD"),(events) => {
          this.setState({
            events: events, 
            loading: false
            })
        })
    );
    }
    this.setState({
      day: moment(date).tz("Europe/London").startOf('day'),
      selectedDay: date
    });
  }

  render () {
    return (
      <Grid>
        <Row>
          <FullDiv>
        <LogoImg src={"logo.jpg"} />
        <TextDiv> Room Bookings </TextDiv>
        </FullDiv>
        <ContactBoldDiv>To book an available room please contact us:  </ContactBoldDiv>
    <ContactdDiv>0207 7323269</ContactdDiv>
    <ContactdDiv>superunisonstudios@gmail.com</ContactdDiv>
        </Row>
        <Row>
          <DateInputSpacer>
          <SingleDatePicker date={this.state.day} 
            onDateChange={date => this.handleChange(date)} 
            focused={this.state.focused} 
            onFocusChange={({ focused }) => this.setState({ focused })}
            isOutsideRange={r => false}
            displayFormat="DD MMM YYYY"
            numberOfMonths={1}
          />
    </DateInputSpacer>
  </Row>
<Row>
    <LoaderDiv>
      <GridLoader
          color={'#4c6090'} 
        loading={this.state.loading} 
        />
        </LoaderDiv>

          <TimetableContainer events={this.state.events} day={this.state.day} />
</Row>
<Row>
  </Row>

      </Grid>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js